// export const isTokenExpired = (token) =>
//   Date.now() >= JSON.parse(atob(token.split('.')[1])).exp * 1000;

import { jwtDecode } from "jwt-decode";
import moment from "moment";
import AuthService from "../services/authService";

export const isTokenExpired = () => {
  const token = AuthService._getAccessToken();
  if (!token) return false;
  const { exp } = jwtDecode(token || "");
  const tokenExp = moment().add(10, "minutes").unix() >= exp;
  return tokenExp;
};
